<div
  class="flex items-center justify-center relative"
  matTooltipPosition="above"
  [class.leading-[1px]]="fontSize() ?? 12 < 12"
  [class.overflow-hidden]="!shouldShowText() && !isIcon()"
  [style.width.px]="calculatedContainerWidth()"
  [style.height.px]="calculatedContainerHeight()"
  [style.color]="color()"
  [style.background-color]="!isNotUploadedImage() && !hasImageError() ? 'transparent' : calculatedBackgroundColor()"
  [style.background]="!isNotUploadedImage() && !hasImageError() ? 'transparent' : calculatedBackgroundColor()"
  [style.border-radius.px]="borderRadius()"
  [style.border-color]="borderWidth() ? (borderColor() ?? 'var(--shikenso-purple-base-border)') : ''"
  [style.border-width.px]="borderWidth()"
  [matTooltip]="tooltipText() ?? ''"
  [matTooltipDisabled]="!tooltipText()"
>
  @if (!shouldShowText()) {
    @if (isIcon()) {
      <app-icon
        [src]="processedImageUrl() ?? content() ?? ''"
        [alt]="alt()"
        [size]="iconSize()"
        [color]="color()"
        [ignoreColor]="ignoreIconColor()"
        [class]="calculatedIconSizeClasses()"
        [noMaskSize]="noMaskSize()"
        [class.invert]="inverted()"
      />
    } @else {
      <img
        class="select-none object-cover w-full h-full"
        [appImageLoader]="isNotUploadedImage() ? '' : (content() ?? '')"
        [attr.src]="isNotUploadedImage() ? (processedImageUrl() ?? content()) : transparentImage"
        [attr.referrerpolicy]="'no-referrer'"
        [alt]="alt()"
        [style.border-radius.px]="isSocialBadge() ? 0 : borderRadius()"
        [class.invert]="inverted()"
        [hidden]="!isNotUploadedImage() && isImageLoading()"
        (error)="onIconError()"
        (imageLoading)="onImageLoading()"
        (imageLoaded)="onImageLoaded()"
        (imageError)="onImageError()"
      />
    }

    @if (isImageLoading()) {
      <ngx-skeleton-loader
        [theme]="{
          width: calculatedContainerWidth() + 'px',
          height: calculatedContainerWidth() + 'px',
          backgroundColor: backgroundColor(),
          'border-radius': borderRadius() + 'px',
        }"
        [style]="{ height: calculatedContainerWidth() + 'px' }"
      />
    }
  } @else {
    <span
      class="leading-[1px]"
      [style.font-weight]="fallbackTextFontWeight()"
      [style.font-size.px]="textSize()"
      [style.padding-top.px]="textTopPadding()"
      [style.color]="color()"
    >
      @if (shortenText()) {
        {{ (fallbackText() ?? '') || (content() ?? '') | firstLetters }}
      } @else {
        {{ (fallbackText() ?? '') || (content() ?? '') }}
      }
    </span>
  }

  @if (showAuthenticationIcon()) {
    <div
      class="flex items-center justify-center absolute bottom-[-1px] right-[-6px] border border-white rounded-full bg-shikenso-success-light w-4 h-4"
    >
      <app-icon src="/icons/security.svg" alt="Authentication Check" class="w-[10px] h-[10px]" />
    </div>
  }
</div>
